export const GET_USERS = 'admin/auth/user/list';

export const DELETE_USERS = 'admin/auth/userDelete';

export const BLOCK_USERS = 'admin/auth/userBlock';

export const APPROVE_USER_DETAILS = 'admin/auth/userApproved';

export const POST_USER_DETAILS = 'admin/auth/signupUser';